import { GatewayNetworkConfigurationValue } from './gateway-network-configuration-value.model';

export class GatewayNetworkConfiguration
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here.
            this.Value = new GatewayNetworkConfigurationValue(json['Value']);
        }
    }

    public Id: number;
    public DeviceId: number;
    public AccountId: number;
    public WhenCreated: Date;
    public WhenLastUpdated: Date;
    public Value: GatewayNetworkConfigurationValue;
}
